"use client";
import React from "react";
import AnimatedTimeline from "@/Components/AnimatedTimeline";

type TimelineItem = {
  id: number;
  title: string;
  description: string;
};

interface AccordionProps {
  steps?: TimelineItem[];
}

const Timeline: React.FC<AccordionProps> = ({ steps }) => {
  return (
    <div className="relative w-full mx-auto mt-[40px]">
      {/* Timeline Items */}
      <div className="flex flex-col gap-[40px]">
        <AnimatedTimeline
          items={steps ?? []}
          activationOffset={0}
          reverseLayout={false}
        />
      </div>
    </div>
  );
};

export default Timeline;
